import { API_URL, apiRequest } from './apiClient';
import { snackError } from '../utils/snackbarBus';

export const getAllServices = async () => {
  return apiRequest('/services');
};

export const getServiceById = async (id) => {
  return apiRequest(`/services/${id}`);
};

export const createService = async (serviceData) => {
  return apiRequest('/services', { method: 'POST', body: serviceData, modelLabel: 'servicio' });
};

export const updateService = async (id, serviceData) => {
  return apiRequest(`/services/${id}`, { method: 'PUT', body: serviceData, modelLabel: 'servicio' });
};

export const deleteService = async (id) => {
  return apiRequest(`/services/${id}`, { method: 'DELETE', modelLabel: 'servicio' });
};

export const getServiceDocuments = async (serviceId) =>
  apiRequest(`/services/${serviceId}/documents`, { showErrorSnack: false });

export const uploadServiceDocument = async (serviceId, type, file) => {
  const body = new FormData();
  body.append('file', file);
  return apiRequest(`/services/${serviceId}/documents/${type}`, {
    method: 'POST',
    body,
    successMessage: 'Se ha subido el archivo correctamente.'
  });
};

export const deleteServiceDocument = async (serviceId, type) =>
  apiRequest(`/services/${serviceId}/documents/${type}`, {
    method: 'DELETE',
    successMessage: 'Se ha eliminado el archivo correctamente.'
  });

export const getServiceDocumentUrl = (serviceId, type) =>
  `${API_URL}/services/${serviceId}/documents/${type}`;

export const downloadServiceDocument = async (serviceId, type, fileName) => {
  try {
    const response = await fetch(`${getServiceDocumentUrl(serviceId, type)}?download=1`);
    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error || response.statusText || 'No se pudo descargar el archivo');
    }

    const fileUrl = window.URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName || `servicio-${serviceId}-${type}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => window.URL.revokeObjectURL(fileUrl), 1000);
  } catch (error) {
    const message = error?.message ? `Error: ${error.message}` : 'Error: No se pudo descargar el archivo';
    snackError(message, 3800);
  }
};
